module.exports = __webpack_public_path__ + "static/logo-tishman-speyer-57e5efbe6765132e1cc103e34d67b0da.png";